import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { RetailItem } from "src/app/particulier/core/model/retail-item";
import { ConditionRetail } from "src/app/particulier/core/model/condition-retail";
import { RetailItemService } from "src/app/particulier/core/service/retail-item.service";
import { ConditionRetailService } from "src/app/particulier/core/service/condition-retail.service";

@Component({
  selector: "app-form-add-condition",
  templateUrl: "./form-add-condition.component.html",
  styleUrls: ["./form-add-condition.component.scss"],
})
export class FormAddConditionComponent implements OnInit {
  @Input() retailItemId;

  requestId: number;

  retailItem: RetailItem;
  condition: ConditionRetail = new ConditionRetail();

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _retailItemService: RetailItemService,
    private _conditionRetailService: ConditionRetailService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      libelle: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getRetailItemById(this.retailItemId);
  }

  getRetailItemById(retailItemId) {
    this._retailItemService.getRetailItemById(retailItemId).subscribe(
      (data) => {
        this.retailItem = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.spinner.show();
    const dateTime = new Date().getTime();

    this.condition.retailItem = this.retailItem;
    this.condition.code = "condition_" + dateTime;
    this.condition.checked = true;

    this._conditionRetailService
      .postConditionRetail(this.condition)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
